const CollectionName = {
  WORKOUT: 'workout',
  WORKOUT_ASSIGNMENT: 'workoutAssignment',
  GAMEPLAY_SESSION: 'gameplaySession',
  USER_DEVICE: 'userDevice',
  USER_ACTIVITY_HISTORY: 'userActivityHistory',
  COACH: 'coach',
  TRACKED_ACTIVITY_SUMMARY: 'trackedActivitySummary',
  WORKOUT_FEED_VIEW: 'workoutFeedView',
  EXERCISE: 'exercise',
  EXERCISE_TAG: 'exerciseTag',
  STREAK: 'streak',
  TRACKED_ACTIVITY: 'trackedActivity',
  REFERRAL_CODE: 'referralCode',
  PRODUCT: 'product',
  PACKAGE: 'package',
  APP_CUSTOMIZATION: 'appCustomization',
  LIBRARY_DOCS: 'product/{productId}/libraryDocs',
  COACH_ASSIGNMENT: 'coachAssignment',
  INTEGRATIONS: 'integrations',
  USER: 'user',
  CONFIG: 'config',
  CLIENT_SMS: 'clientSMS',
  TAG: 'tag',
  PRICE: 'price',
  EXTERNAL_COACH: 'externalCoach',
  EXTERNAL_COACH_PRIVATE: 'externalCoachPrivate',
  MEAL_PLAN: 'mealPlan',
  MEAL_PLAN_VIEW: 'mealPlanView',
  MEAL_PLAN_ASSIGNMENT: 'mealPlanAssignment',
  CLIENT_MEAL_ASSIGNMENT_VIEW: 'clientMealAssignmentView',
  MESSAGE_SUGGESTION: 'messageSuggestion',
  LEADS: 'leads',
  LEAD_HISTORY: 'leadHistory',
  LEAD_MSGS: 'leadMsgs',
  LEAD_CAMPAIGN: 'leadCampaign',
  LEAD_CAMPAIGN_MSGS: 'leadCampaignMsgs',
  LEAD_REENGAGEMENT_SEQUENCES: 'leadReengagementSequences',
  FORMS: 'forms',
  BROADCAST_MESSAGE: 'broadcastMessage',
  BROADCAST_MESSAGE_REQUEST: 'broadcastMessageRequest',
  NUTRITION_PLAN: 'nutritionPlan',
  NUTRITION_PLAN_REQUEST: 'nutritionPlanRequest',
  SUGGESTIC_RECIPE: 'integrations/suggestic/recipe',
  COACH_ONBOARDING: 'coachOnboarding',
  USER_ACTIVITY_PROFILE: 'userActivityProfile',
  USER_NUTRITION_PROFILE: 'userNutritionProfile',
  USER_NUTRITION_LOG: 'userNutritionLog',
  USER_NUTRITION_MACRO_GOALS: 'userNutritionMacroGoals',
  COUPON: 'coupon',
  HABIT_LOG: 'habitLog',
  APP_CUSTOM_HABIT: 'appCustomHabits',
  RECIPE: 'recipe',
  INGREDIENT: 'ingredient',
  USER_CONTRACT: 'userContract',
  POST_PAYMENT_FORM_ANSWER: 'postPaymentFormAnswer',
  WEEKLY_CHECKIN: 'weeklyCheckin',
  ANALYTICS: 'analytics/{userType}/{analyticType}/{frequency}/{userId}',
  MSG_TEMPLATES: 'isConfigs/msgTemplates',
  EMAIL_TEMPLATES: 'isConfigs/emailTemplates',
  COACH_INFO: 'isConfigs/coachInfo',
  PROMOTIONS: 'isConfigs/promotions',
  COACH_REMINDER_NOTIFICATION: 'coachReminderNotification',
  APP_CUSTOM_CHECK_IN: 'appCustomCheckIn',
  APP_CUSTOM_THEME: 'appCustomTheme',
  INTERNAL_ASSIGNMENT: 'internalAssignment',
  EXCHANGE_RATES: 'exchangeRates',
  COACH_ACTIVITY: 'coachActivity',
  CONTENT_HIGHLIGHT: 'contentHighlight',
  PAUSE_INTERVENTION: 'pauseIntervention',
  ON_HOLD_WORKOUT_REVIEW: 'onHoldWorkoutReview',
  METABASE_DASHBOARD: 'metabaseDashboard',
  CHECK_IN_FEEDBACK: 'checkInFeedback',
  MSG_ENDPOINT: 'msgEndpoint',
  DRAFT_MESSAGE: 'draftMessage',
  PROGRAM: 'program',
  TRACK: 'track',
  TRACK_ASSIGNMENT: 'trackAssignment',
  COACH_CONFIG: 'coachConfig',
  UPSELL_CONFIG: 'upsellConfig',
  COACH_NOTIFICATION_VIEW: 'coachNotificationView',
  CHECK_IN: 'checkIn',
  CHAT_CHANNEL: 'chatChannel',
  USER_CLAIMS: 'userClaims',
  USER_ACTIVITY: 'userActivity',
  CHAT_MESSAGE_REQUEST: 'chatMessageRequest',
  COACH_HISTORY: 'coachHistory',
  ROLE: 'role',
  TODO: 'toDo',
  INSTAGRAM_MEDIA: 'instagramMedia',
  INSTAGRAM_USER: 'instagramUser',
  COACH_OFFBOARDING_NOTE: 'coachOffboardingNote',
  COACH_VOICE: 'coachVoice',
  ANNOUNCEMENT: 'announcement',
  COMMUNITY: 'community',
  COACH_POD: 'coachPod',
  RECIPE_PREFERENCE: 'recipePreference',
  LEAD_CONFIG: 'isConfigs/leadConfig',
  ANNOUNCEMENT_COMMENT_REPORT: 'announcementCommentReport',
  ANNOUNCEMENT_COMMENT: 'announcementComment',
  CHECK_IN_THEMES: 'checkInThemes',
  MEAL_PLAN_CREATION_REQUEST: 'mealPlanCreationRequest',
  USER_PRESENCE: 'userPresence',
  USER_SESSIONS: 'userPresence/{userId}/userSessions',
  SMART_CHECK_IN_REPLY: 'smartCheckInReply',
  IS_AVAILABILITY_FOR_CALLS: 'isAvailabilityForCalls',
  COACH_IDENTITY: 'coachIdentity',
  SMART_CONTEXT_RESPONSES_CACHE: 'smartContextResponsesCache',
  CHALLENGE_CONFIG: 'challengeConfig',
  WORKOUT_REQUEST: 'workoutRequest',
  CHECKOUT_SESSION_ONBOARDING: 'checkoutSessionOnboarding',
  LEAD_CONVERSATION: 'leadConversation',
  USER_ACTION_ITEMS: 'userActionItems',
  SCHEDULED_ASSIGNMENT: 'scheduledAssignment',
  WORKOUT_PICKS: 'workoutPicks',
  USER_EXERCISE_OVERRIDES: 'userExerciseOverrides',
  RELEASE_NOTE: 'releaseNote',
  BULK_EXERCISE_CREATE_SESSION: 'bulkExerciseCreateSession',
  MIGRATION_RUN: 'migrationRun',
  // Menstrual cycle tracker: one doc per client, with a `dayLogs` subcollection (one doc per logged day).
  CYCLE_HEALTH: 'cycleHealth',
  CYCLE_HEALTH_DAY_LOGS: 'dayLogs',
  WEBFLOW_DEPLOYS: 'webflowDeploys',
};

export default CollectionName;
